import { combineReducers } from 'redux';

import {
  LIBRARY_SALES_TYPE_HUB_SET_LIST_SALES,
  LIBRARY_SALES_TYPE_HUB_SET_META_SALES_TYPE,
  LIBRARY_SALES_TYPE_HUB_OPEN_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_HUB_CLOSE_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_HUB_SET_SALES_DETAIL,
  LIBRARY_SALES_TYPE_HUB_SET_STATUS_GRATUITY,
  LIBRARY_SALES_TYPE_HUB_SET_GRATUITY,
  LIBRARY_SALES_TYPE_HUB_IS_SUBMITTING_FORM,
  LIBRARY_SALES_TYPE_HUB_SHOW_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_HUB_HIDE_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_HUB_SET_DELETED_SALES,
  LIBRARY_SALES_TYPE_HUB_SHOW_DELETE_MODAL,
  LIBRARY_SALES_TYPE_HUB_HIDE_DELETE_MODAL,
  LIBRARY_SALES_TYPE_HUB_SHOW_CHECK_DELETABLE_MODAL,
  LIBRARY_SALES_TYPE_HUB_SET_CHANNEL_ASYNC_JOB,
} from 'actions/businessLibrary/salesType/constants';
import createReducer from 'utils/createReducer';

const salesType = createReducer([], {
  [LIBRARY_SALES_TYPE_HUB_SET_LIST_SALES]: (_, { payload }) =>
    payload.salesType,
});

const salesTypeMeta = createReducer(
  {},
  {
    [LIBRARY_SALES_TYPE_HUB_SET_META_SALES_TYPE]: (_, { payload }) =>
      payload.meta,
  }
);

const openRightColumn = createReducer(false, {
  [LIBRARY_SALES_TYPE_HUB_CLOSE_RIGHT_COLUMN]: () => false,
  [LIBRARY_SALES_TYPE_HUB_OPEN_RIGHT_COLUMN]: () => true,
});

const salesTypeDetail = createReducer(null, {
  [LIBRARY_SALES_TYPE_HUB_SET_SALES_DETAIL]: (draft, { payload }) =>
    payload.salesTypeDetail,
});

const enableGratuity = createReducer(null, {
  [LIBRARY_SALES_TYPE_HUB_SET_STATUS_GRATUITY]: (draft, { payload }) =>
    payload.enableGratuity,
});

const gratuity = createReducer([], {
  [LIBRARY_SALES_TYPE_HUB_SET_GRATUITY]: (_, { payload }) => payload.gratuity,
});

const isSubmittingForm = createReducer(false, {
  [LIBRARY_SALES_TYPE_HUB_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const noGratuityModal = createReducer(false, {
  [LIBRARY_SALES_TYPE_HUB_SHOW_NO_GRATUITY_MODAL]: () => true,
  [LIBRARY_SALES_TYPE_HUB_HIDE_NO_GRATUITY_MODAL]: () => false,
});

const deletedSalesType = createReducer(null, {
  [LIBRARY_SALES_TYPE_HUB_SET_DELETED_SALES]: (_, { payload }) =>
    payload.deletedSalesType,
});

const showDeleteModal = createReducer(false, {
  [LIBRARY_SALES_TYPE_HUB_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_SALES_TYPE_HUB_HIDE_DELETE_MODAL]: () => false,
});

const showCheckDeletableModal = createReducer(false, {
  [LIBRARY_SALES_TYPE_HUB_SHOW_CHECK_DELETABLE_MODAL]: (_, { payload }) =>
    payload.showCheckDeletableModal,
});

const checkDeletableModalType = createReducer('', {
  [LIBRARY_SALES_TYPE_HUB_SHOW_CHECK_DELETABLE_MODAL]: (draft, { payload }) =>
    payload.type,
});

const eventAsyncJob = createReducer(
  {
    channelName: null,
  },
  {
    [LIBRARY_SALES_TYPE_HUB_SET_CHANNEL_ASYNC_JOB]: (_, { payload }) => ({
      ...payload,
    }),
  }
);

export default combineReducers({
  checkDeletableModalType,
  deletedSalesType,
  enableGratuity,
  eventAsyncJob,
  gratuity,
  isSubmittingForm,
  noGratuityModal,
  openRightColumn,
  salesType,
  salesTypeDetail,
  salesTypeMeta,
  showCheckDeletableModal,
  showDeleteModal,
});
